module.exports = __webpack_public_path__ + "img/kybernetwork.491083a9.jpeg";